import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useRouterState } from '@tanstack/react-router';
import type React from 'react';
import { useMemo } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { employeeService } from '../services/employeeService';
import { EmployeeList } from './EmployeeList';
import { WorkingTimeModelList } from './WorkingTimeModelList';

export const EmployeeSettings: React.FC = () => {
  const queryClient = useQueryClient();
  const router = useRouterState();

  const currentPath = router.location.pathname;
  const activeView = useMemo(() => {
    if (currentPath.includes('/working-time-model')) return 'working-time-model';
    return 'employee-management';
  }, [currentPath]);

  const {
    data: employees,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['employees'],
    queryFn: employeeService.getEmployees,
    refetchOnMount: 'always',
  });

  return (
    <div className="p-2">
      {activeView === 'employee-management' ? (
        isLoading ? (
          <div className="flex flex-col items-center justify-center gap-4 p-8 text-text-secondary">
            <Spinner className="size-10" />
            <p>Loading employees...</p>
          </div>
        ) : error ? (
          <div className="flex flex-col items-center p-8 text-danger-600">
            <p>Error loading employees: {error.message}</p>
            <Button type="button" className="mt-4" onClick={() => refetch()}>
              Retry
            </Button>
          </div>
        ) : (
          <EmployeeList
            employees={employees ?? []}
            onEdit={(_employee) => {}}
            onDelete={(employeeId) => {
              toast.info(`Delete employee: ${employeeId}`);
            }}
            onAdd={() => {}}
            onView={(employee) => {
              toast.info(`View employee: ${employee.fullname}`);
            }}
            onEmployeeSaved={() => {
              void queryClient.invalidateQueries({ queryKey: ['employees'] });
            }}
          />
        )
      ) : (
        <WorkingTimeModelList
          onEdit={(_model) => {}}
          onDelete={(modelId) => {
            toast.info(`Delete working time model: ${modelId}`);
          }}
          onAdd={() => {}}
          onView={(_model) => {}}
        />
      )}
    </div>
  );
};
